import { render, staticRenderFns } from "./MortgageCalculatorContent.vue?vue&type=template&id=08dd345d&scoped=true"
import script from "./MortgageCalculatorContent.vue?vue&type=script&lang=js"
export * from "./MortgageCalculatorContent.vue?vue&type=script&lang=js"
import style0 from "./MortgageCalculatorContent.vue?vue&type=style&index=0&id=08dd345d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dd345d",
  null
  
)

export default component.exports